<template>
  <div class="content-card">
    <img :src="image"
      class="content-img"
      alt="speakol"/>

      <div class="content-text">
        <div class="title text-center">
          <slot name="title"></slot>
        </div>
        <div class="text-center content-div content">
          {{ text }}
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: ['image', 'title', 'text']
}
</script>

<style scoped>
.content-card {
  border-radius: 3px;
}

.content-img {
  width: 25%;
  margin-left: 37%;
}

.content-div {
  margin: 1% 15% 1% 15%;
}

.title {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  letter-spacing: 0.1px;
  color: #2c2c2c;
}

.content {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.10000000149011612px;
  text-align: center;
}

.con-vs-card {
  height: 600px;
}

@media (max-width: 768px) {
  .content-card {
    border-radius: 3px;
    max-height: 500px;
    overflow: scroll;
  }

  .content-img {
    width: 58%;
    margin-left: 26%;
  }

  .content-div {
    margin: 0 0% 0 0%;
  }

  .title {
    font-size: 20px;
  }
}

</style>
